import { render, staticRenderFns } from "./maintenance-notice.vue?vue&type=template&id=b8838390"
import script from "./maintenance-notice.vue?vue&type=script&lang=ts"
export * from "./maintenance-notice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports